import React from 'react';
import { Trophy, Users, Clock, Star, ArrowRight } from 'lucide-react';

const ActiveCompetitions: React.FC = () => {
  const competitions = [
    {
      id: '1',
      name: 'Gold Rush Challenge',
      prize: '$5,000',
      participants: 234,
      timeLeft: '2d 14h',
      position: 12,
      progress: 78,
      type: 'Weekly',
      status: 'active'
    },
    {
      id: '2',
      name: 'AI Trading Masters',
      prize: '$2,500',
      participants: 89,
      timeLeft: '5d 8h',
      position: 7,
      progress: 65,
      type: 'AI Only',
      status: 'active'
    },
    {
      id: '3',
      name: 'Rookie Traders Cup',
      prize: '$1,000',
      participants: 156,
      timeLeft: '12h 32m',
      position: 23,
      progress: 45,
      type: 'Beginner',
      status: 'ending'
    }
  ];

  return (
    <div className="win-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-win-dark-gold/20 rounded-2xl">
            <Trophy className="w-5 h-5 text-win-dark-gold" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-win-dark-text">Active Competitions</h2>
            <p className="text-sm text-win-dark-text-muted">Join and compete with other traders</p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {competitions.map((comp) => (
          <div 
            key={comp.id} 
            className={`p-4 rounded-3xl border transition-all duration-200 hover:scale-[1.02] cursor-pointer ${
              comp.status === 'ending' 
                ? 'bg-gradient-to-r from-win-dark-surface to-orange-500/10 border-orange-500/30' 
                : 'bg-win-dark-surface-light border-win-dark-border hover:border-win-dark-accent/50'
            }`}
          >
            {/* Competition Header */}
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-bold text-win-dark-text">{comp.name}</h3>
                  <span className={`win-badge ${
                    comp.type === 'AI Only' ? 'win-badge-success' :
                    comp.type === 'Beginner' ? 'win-badge-warning' :
                    'win-badge win-badge-gold'
                  }`}>
                    {comp.type}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-win-dark-text-muted">
                  <div className="flex items-center gap-1">
                    <Trophy className="w-3 h-3" />
                    <span>{comp.prize}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Users className="w-3 h-3" />
                    <span>{comp.participants} traders</span>
                  </div>
                </div>
              </div>
              
              {comp.status === 'ending' && (
                <div className="win-badge bg-orange-500/20 text-orange-400 border-orange-500/30">
                  Ending Soon
                </div>
              )}
            </div>

            {/* Position & Progress */}
            <div className="mb-3">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Star className="w-4 h-4 text-win-dark-gold" />
                  <span className="text-sm font-medium text-win-dark-text">
                    Position #{comp.position}
                  </span>
                </div>
                <div className="flex items-center gap-1 text-sm text-win-dark-text-muted">
                  <Clock className="w-3 h-3" />
                  <span>{comp.timeLeft} left</span>
                </div>
              </div>
              
              {/* Progress Bar */}
              <div className="w-full bg-win-dark-border rounded-full h-2">
                <div 
                  className="bg-gradient-to-r from-win-dark-gold to-yellow-500 h-2 rounded-full transition-all duration-500"
                  style={{ width: `${comp.progress}%` }}
                ></div>
              </div>
            </div>

            {/* Action Button */}
            <button className="w-full flex items-center justify-center gap-2 p-3 bg-win-dark-surface hover:bg-win-dark-accent rounded-3xl transition-all duration-200 group">
              <span className="font-medium text-win-dark-text group-hover:text-white">
                View Competition
              </span>
              <ArrowRight className="w-4 h-4 text-win-dark-text-muted group-hover:text-white" />
            </button>
          </div>
        ))}
      </div>

      {/* Join New Competition */}
      <div className="mt-6 pt-4 border-t border-win-dark-border">
        <button className="w-full win-button flex items-center justify-center gap-2">
          <Trophy className="w-5 h-5" />
          <span>Browse All Competitions</span>
        </button>
      </div>
    </div>
  );
};

export default ActiveCompetitions;